import { COMMENT_REPORT_TYPES, COMMENT_CUSTOM_FUND_NAMES } from './constants';

export const getReportType = (pathName?: string) => {
  try {
    if (pathName?.startsWith('/report/fca')) return COMMENT_REPORT_TYPES.FCA;
    if (pathName?.startsWith('/report/pf')) return COMMENT_REPORT_TYPES.FORM_PF;
    if (pathName?.startsWith('/report/esma')) return COMMENT_REPORT_TYPES.ESMA;

    return COMMENT_REPORT_TYPES.ESMA;
  } catch {
    return COMMENT_REPORT_TYPES.ESMA;
  }
};

export const getCustomFundNameForAIFM = (type?: string) => {
  if (type === COMMENT_REPORT_TYPES.FCA) return COMMENT_CUSTOM_FUND_NAMES.FCA_FUND_NAME;
  if (type === COMMENT_REPORT_TYPES.ESMA) return COMMENT_CUSTOM_FUND_NAMES.ESMA_FUND_NAME;
  if (type === COMMENT_REPORT_TYPES.FORM_PF) return COMMENT_CUSTOM_FUND_NAMES.FORM_PF_FUND_NAME;

  return COMMENT_CUSTOM_FUND_NAMES.ESMA_FUND_NAME;
};
